export default __webpack_public_path__ + "static/media/49t.41efab24.jpg";